/** Arch transaction ids are 32-byte digests shown as 64 hex chars. */

const TX_HEX = /^[0-9a-f]{64}$/i;

/** True when `id` is a 64-char hex Arch transaction hash. */
export function isValidTxId(id: string): boolean {
  return TX_HEX.test(id.trim());
}

/** Normalize a candidate to lowercase hex, or null if invalid. */
export function normalizeTxId(id: unknown): string | null {
  if (typeof id !== "string" && typeof id !== "number") return null;
  const raw = String(id).trim().replace(/^0x/i, "");
  if (!TX_HEX.test(raw)) return null;
  return raw.toLowerCase();
}
